import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync, LL_H_C, LL_V_L, ModuleFE_Thunderstorm } from '@nu-art/thunderstorm-frontend/index';
import { QJSONViewer } from '@app/hcs-frontend';
import { __stringify } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
export class Component_MessageCard extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.toggleTechnicalView = !nextProps.prettyViewRenderer;
        return state;
    }
    copyResponseToClipboard = async (history) => {
        try {
            let contentToCopy;
            if (typeof history.content === 'object') {
                contentToCopy = __stringify(history.content, true);
            }
            else if (typeof history.content === 'string') {
                // Try to parse and pretty-print if it's JSON
                try {
                    const parsed = JSON.parse(history.content);
                    contentToCopy = __stringify(parsed, true);
                }
                catch {
                    contentToCopy = history.content;
                }
            }
            else {
                contentToCopy = __stringify(history.content, true);
            }
            await ModuleFE_Thunderstorm.copyToClipboard(contentToCopy);
        }
        catch (e) {
            console.error('Failed to copy to clipboard', e);
        }
    };
    defaultTechnicalRenderer = (history, index) => {
        let ToRender;
        try {
            const item = typeof history.content === 'object' ? history.content : JSON.parse(history.content);
            ToRender = _jsx(QJSONViewer, { item: item }, index);
        }
        catch (e) {
            ToRender = _jsx(React.Fragment, { children: __stringify(history.content) }, index);
        }
        try {
            return ToRender;
        }
        catch (e) {
            return _jsxs(_Fragment, { children: ["Failed ", e.message()] });
        }
    };
    render() {
        const isReceived = this.props.historyItem.type === 'received';
        return _jsxs(LL_V_L, { className: this.props.className, children: [_jsxs(LL_H_C, { style: { justifyContent: 'flex-end', padding: '3px 3px 0 0', gap: '5px' }, className: 'match_width', children: [isReceived &&
                            _jsx(ICONS.copy.component, { onClick: () => this.copyResponseToClipboard(this.props.historyItem), style: { cursor: 'pointer' }, title: "Copy response JSON to clipboard" }), !!this.props.prettyViewRenderer &&
                            _jsx(ICONS.debug.component, { onClick: () => this.setState({ toggleTechnicalView: !this.state.toggleTechnicalView }), style: { cursor: 'pointer' } })] }), !this.state.toggleTechnicalView ? this.props.prettyViewRenderer : this.defaultTechnicalRenderer(this.props.historyItem, this.props.index)] });
    }
}
//# sourceMappingURL=Component_MessageCard.js.map